// Generated from Info/DBD Killer Perks — Base mécanique.md.
// Do not hand-edit individual descriptions here; update the source file and regenerate.

export const killerPerkDetails = {
  a_nurse_s_calling: {
    sourceName: "A Nurse's Calling",
    officialDescription: 'Within 32m of injured Survivors who are healing or being healed, you see their Auras.'
  },
  agitation: {
    sourceName: 'Agitation',
    officialDescription: 'While carrying a Survivor:\nYou gain 18% Haste.\nYour Terror Radius is 12m larger.'
  },
  alien_instinct: {
    sourceName: 'Alien Instinct',
    officialDescription: 'Whenever you hook a Survivor, the farthest injured Survivor:\nGains Oblivious for 60s.\nYou see their Aura for 8s.'
  },
  all_shaking_thunder: {
    sourceName: 'All-Shaking Thunder',
    officialDescription: 'Whenever you fall from at least 1.25m, your lunge-attacks are 75% longer for 25s. Cooldown: 5s.'
  },
  awakened_awareness: {
    sourceName: 'Awakened Awareness',
    officialDescription: 'While carrying a Survivor, within 20m of you, you see the Auras of other Survivors.'
  },
  bamboozle: {
    sourceName: 'Bamboozle',
    officialDescription: 'Whenever you vault a Window, it is blocked for Survivors for 16s.\nYou basic-vault Windows 15% faster.\nOnly 1 Window can be blocked at a time.'
  },
  barbecue_chili: {
    sourceName: 'Barbecue & Chili',
    officialDescription: 'Whenever you hook a Survivor, for 5s, you see the Auras of all Survivors who are at least 40m away from the hooked Survivor.'
  },
  batteries_included: {
    sourceName: 'Batteries Included',
    officialDescription: 'Within 16m of a completed Generator, you gain 5% Haste. When you leave the range, this ends after 5s.'
  },
  beast_of_prey: {
    sourceName: 'Beast of Prey',
    officialDescription: 'Whenever you gain Bloodlust, gain Undetectable for 40s.'
  },
  bitter_murmur: {
    sourceName: 'Bitter Murmur',
    officialDescription: 'Whenever a Generator is completed, you see the Auras of Survivors within 16m of it for 5s.\nWhen all Generators are completed, you see the Auras of all Survivors for 10s.'
  },
  blood_echo: {
    sourceName: 'Blood Echo',
    officialDescription: 'Whenever you hook a Survivor, for 30s, all injured Survivors:\nGain Exhausted.\nGain Hemorrhage.'
  },
  blood_warden: {
    sourceName: 'Blood Warden',
    officialDescription: 'When an Exit Gate is opened, once per trial, when you hook a Survivor, both Exits are blocked for 60s.\nYou see the Auras of Survivors within Exit Thresholds.'
  },
  bloodhound: {
    sourceName: 'Bloodhound',
    officialDescription: 'Pools of Blood are brighter and last 4s longer.'
  },
  brutal_strength: {
    sourceName: 'Brutal Strength',
    officialDescription: 'You basic-break Pallets and Breakable Walls, and damage Generators 20% faster.'
  },
  call_of_brine: {
    sourceName: 'Call of Brine',
    officialDescription: 'Whenever you damage a Generator, it regresses 50% faster for 70s.\nFor that time, whenever a Survivor hits a good basic Skill Check while repairing that Generator, you are alerted.'
  },
  corrupt_intervention: {
    sourceName: 'Corrupt Intervention',
    officialDescription: 'When the trial starts, the 3 farthest Generators from you are blocked for 120s, or until you down a Survivor.'
  },
  coulrophobia: {
    sourceName: 'Coulrophobia',
    officialDescription: 'Survivors within your Terror Radius:\nHeal 50% slower.\nWhile healing, basic Skill Checks spin 50% faster.'
  },
  coup_de_grace: {
    sourceName: 'Coup de Grâce',
    officialDescription: 'Whenever a Generator is completed, you earn 2 Tokens, up to 5.\nWhenever you lunge-attack, spend 1 Token to make it 80% longer.'
  },
  cruel_limits: {
    sourceName: 'Cruel Limits',
    officialDescription: 'Whenever a Generator is completed:\nYou see the Auras of all Windows for 30s.\nAll Windows are blocked for Survivors for 30s.'
  },
  dark_arrogance: {
    sourceName: 'Dark Arrogance',
    officialDescription: 'You basic-vault Windows 25% faster.\nWhenever you are blinded or Pallet-stunned, the duration is 15% longer.'
  },
  dark_devotion: {
    sourceName: 'Dark Devotion',
    officialDescription: 'Whenever the Obsession takes damage, for 45s:\nYour Terror Radius is set to 40m.\nThe Obsession has your Terror Radius.\nYou gain Undetectable.'
  },
  darkness_revealed: {
    sourceName: 'Darkness Revealed',
    officialDescription: 'Whenever you search a Locker, you see the Auras of Survivors within 8m of Lockers for 8s. Cooldown: 30s.'
  },
  dead_man_s_switch: {
    sourceName: 'Dead Man’s Switch',
    officialDescription: 'When you hook a Survivor, the first time a Survivor stops repairing a Generator, it is blocked for 35s. Cooldown: 35s.'
  },
  deadlock: {
    sourceName: 'Deadlock',
    officialDescription: 'Whenever a Generator is completed, the Generator with the most progress is blocked for 25s.'
  },
  deathbound: {
    sourceName: 'Deathbound',
    officialDescription: "Whenever a Survivor finishes healing another, they scream. Then, until they take damage, while they are at least 4m away from that Survivor:\nThey gain Oblivious.\nThey see that Survivor's Aura."
  },
  deerstalker: {
    sourceName: 'Deerstalker',
    officialDescription: 'Every 30s, the Survivor with the least time in chase sees your Aura for 3s.\nWhile a Survivor sees your Aura, you see their Aura.'
  },
  discordance: {
    sourceName: 'Discordance',
    officialDescription: 'Within 128m of you, whenever a Generator is being repaired by at least 2 Survivors, you are alerted.\nWhile that Generator is being repaired by at least 2 Survivors, you see its Aura. When it is no longer being repaired by at least 2 Survivors, this ends after 4s.'
  },
  dissolution: {
    sourceName: 'Dissolution',
    officialDescription: '3s after a Survivor takes damage, for 20s, the next time a Survivor fast-vaults a Pallet while within your Terror Radius, it is destroyed.'
  },
  distressing: {
    sourceName: 'Distressing',
    officialDescription: 'Your Terror Radius is 30% larger.'
  },
  dominance: {
    sourceName: 'Dominance',
    officialDescription: 'The first time each Chest is being unlocked and each Totem is being blessed or cleansed by a Survivor, it is blocked for 16s.'
  },
  dragon_s_grip: {
    sourceName: 'Dragon’s Grip',
    officialDescription: 'Whenever you damage a Generator, for the next 30s, the first Survivor that repairs that Generator:\nThey scream, then you are alerted to their position for 4s.\nThey gain Exposed for 60s.\nCooldown: 30s.'
  },
  dying_light: {
    sourceName: 'Dying Light',
    officialDescription: 'Whenever you hook a Survivor that is not the Obsession, earn 1 token.\nWhile the Obsession is alive, for each Token:\nOther Survivors heal 3% slower.\nOther Survivors repair 3% slower.\nOther Survivors sabotage Hooks 3% slower.\nThe Obsession:\nHeals other Survivors 33% faster.\nUnhooks other Survivors 33% faster.'
  },
  enduring: {
    sourceName: 'Enduring',
    officialDescription: 'While not carrying a Survivor, Pallet-stuns are 50% shorter.'
  },
  eruption: {
    sourceName: 'Eruption',
    officialDescription: 'Whenever you damage a Generator, when you down a Survivor, all Generators damaged this way:\nExplode, lose 10% progress and start regressing.\nSurvivors repairing them scream, then you see their Auras for 12s.\nCooldown: 30s.'
  },
  fire_up: {
    sourceName: 'Fire Up',
    officialDescription: 'Whenever a Generator is completed, earn 1 Token, up to 5.\nFor each Token:\nYou basic-break Pallets and Breakable Walls 6% faster.\nYou damage Generators 6% faster.\nYou pick-up and drop Survivors 6% faster.\nYou basic-vault Windows 6% faster.'
  },
  forced_hesitation: {
    sourceName: 'Forced Hesitation',
    officialDescription: 'Whenever you down a Survivor, other Survivors within 16m of the downed Survivor gain 20% Hindered for 10s. Cooldown: 30s.'
  },
  forced_penance: {
    sourceName: 'Forced Penance',
    officialDescription: 'Whenever a Survivor takes a protection hit, they gain Broken for 80s.'
  },
  forever_entwined: {
    sourceName: 'Forever Entwined',
    officialDescription: 'Whenever a Survivor takes damage, you earn 1 Token, up to 6/7/8.\nFor each Token:\nYou hook Survivors 4% faster.\nYou pick-up and drop Survivors 4% faster.'
  },
  franklin_s_demise: {
    sourceName: "Franklin's Demise",
    officialDescription: 'Whenever you damage a Survivor with a basic attack, they drop their item.\nWithin 64m, you see the Auras of dropped items.'
  },
  friends_til_the_end: {
    sourceName: 'Friends ‘Til the End',
    officialDescription: "Whenever you hook a Survivor that is not the Obsession:\nThe Obsession gains Exposed for 20s.\nYou see the Obsession's Aura for 10s.\nWhenever you hook the Obsession, another Survivor:\nScreams, then you are alerted.\nBecomes the Obsession."
  },
  furtive_chase: {
    sourceName: 'Furtive Chase',
    officialDescription: 'Whenever you hook the Obsession:\nYou gain 10% Haste for 18s.\nYou gain Undetectable for 18s.\nWhenever the Obsession is unhooked, the Survivor who unhooked them becomes the Obsession.'
  },
  game_afoot: {
    sourceName: 'Game Afoot',
    officialDescription: 'While chasing the Obsession, whenever you basic-break Pallets or Breakable Walls, or damage Generators, you gain 7% Haste for 10s.\nWhenever you damage the Survivor with the most chase time with a basic-attack, they become the Obsession.'
  },
  gearhead: {
    sourceName: 'Gearhead',
    officialDescription: 'Whenever a Survivor takes damage, for the next 30s, whenever a Survivor repairing a Generator hits a good basic Skill Check, you see their Aura for 8s.'
  },
  genetic_limits: {
    sourceName: 'Genetic Limits',
    officialDescription: 'Whenever a Survivor takes damage, they gain Exhausted for 8s.'
  },
  grim_embrace: {
    sourceName: 'Grim Embrace',
    officialDescription: "Whenever you hook a Survivor for the first time, earn 1 Token.\nWhen you move 16m away from the hooked Survivor, all Generators are blocked for 10s.\nWhen you have 4 Tokens, when you move 16m away from the hooked Survivor:\nAll Generators are blocked for 40s.\nYou see the Obsession's Aura for 10s."
  },
  haywire: {
    sourceName: 'Haywire',
    officialDescription: 'Exit Gate Switches with at least 80% progress regress at 100% speed.\nWhile they are regressing, Survivors see the Exit Gate Lights flicker randomly.'
  },
  help_wanted: {
    sourceName: 'Help Wanted',
    officialDescription: 'Whenever you damage a Generator, it is compromised.\nWhen that Generator is completed by Survivors, your basic-attack cooldowns are 25% shorter for 60s.\nOnly 1 Generator can be compromised at a time.'
  },
  hex_blood_favor: {
    sourceName: 'Hex: Blood Favor',
    officialDescription: 'When the trial starts, a Dull Totem ignites.\nWhenever you damage a Survivor, Upright Pallets within 32m of them are blocked for 15s.'
  },
  hex_crowd_control: {
    sourceName: 'Hex: Crowd Control',
    officialDescription: 'The first time a Survivor medium or fast-vaults a Window, a Dull Totem ignites.\nThe last 6 Windows Survivors medium or fast-vault are blocked.\nYou basic-vault blocked Windows 15% faster.\nYou see the Auras of blocked Windows within 24m.'
  },
  hex_devour_hope: {
    sourceName: 'Hex: Devour Hope',
    officialDescription: 'When the trial starts, a Dull Totem ignites.\nWhenever a Survivor is unhooked while you are at least 24m away, earn 1 Token, up to 5:\n2 Tokens | 10s after hooking a Survivor, gain 5% Haste for 10s.\n3 Tokens | Survivors gain Exposed.\n5 Tokens | You can Kill downed Survivors.'
  },
  hex_face_the_darkness: {
    sourceName: 'Hex: Face the Darkness',
    officialDescription: 'Whenever you damage a Survivor, they are hexed and a Dull Totem ignites.\nEvery 25s, other Survivors not within your Terror Radius scream, then you see their Auras for 2s.\nWhen the hexed Survivor is downed or becomes healthy, the Hex Totem is extinguished.'
  },
  hex_haunted_ground: {
    sourceName: 'Hex: Haunted Ground',
    officialDescription: 'When the trial starts, 2 Dull Totems ignite.\nWhen either of those Hex Totems is blessed or cleansed:\nAll Survivors gain Exposed for 60s.\nThe other Totem is extinguished.'
  },
  hex_hive_mind: {
    sourceName: 'Hex: Hive Mind',
    officialDescription: 'The first time you hook a Survivor, a Dull Totem ignites.\nThe Auras of Generators show their progress.\nWhen 1 Generator remains:\nAll Generators explode, lose 10% progress and start regressing.\nThe Hex Totem is extinguished.'
  },
  hex_huntress_lullaby: {
    sourceName: 'Hex: Huntress Lullaby',
    officialDescription: "When the trial starts, a Dull Totem ignites.\nWhenever you hook a Survivor, earn 1 Token. For each Token, Basic Skill Check warnings appear later and good success zones are smaller.\nWhile you have 5 Tokens, Basic Skill Check warnings don't appear.\nWhenever a Survivor misses a basic Skill Check, they lose 6% more progress."
  },
  hex_no_one_escapes_death: {
    sourceName: 'Hex: No One Escapes Death',
    officialDescription: "When all Generators are completed, a Dull Totem ignites:\nSurvivors gain Exposed.\nYou gain 4% Haste.\nWithin 4m, Survivors see the Hex Totem's Aura, expanding to 24m over 30s."
  },
  hex_nothing_but_misery: {
    sourceName: 'Hex: Nothing But Misery',
    officialDescription: 'After you damage Survivors with a basic-attack 8 times, a Dull Totem ignites.\nWhenever you damage a Survivor with a basic-attack, they gain 5% Hindered for 15s.'
  },
  hex_overture_of_doom: {
    sourceName: 'Hex: Overture of Doom',
    officialDescription: 'When the trial starts, a Dull Totem ignites and hexes the farthest Generator from it.\nAfter a Survivor repairs the hexed Generator for 5 seconds:\nYou gain Undetectable for 30s.\nFor that time, your Terror Radius is set to that Generator.\nWhen the hexed Generator is repaired, the next farthest Generator is hexed.'
  },
  hex_pentimento: {
    sourceName: 'Hex: Pentimento',
    officialDescription: 'You see the Auras of cleansed Totems, and can rekindle each once.\nWithin 16m, Survivors see the Auras of Rekindled Totems.\nWhile a totem is rekindled, Survivors heal and repair 20% slower, plus 3% for each additional Rekindled Totem.\nWhen all 5 Totems are rekindled at once, they are blocked.'
  },
  hex_plaything: {
    sourceName: 'Hex: Plaything',
    officialDescription: "The first time you hook each Survivor, they are hexed and a Dull Totem ignites.\nFor 90s, the Hex Totem is blocked to other Survivors.\nThe hexed Survivors:\nGain Oblivious.\nWithin 16m of the Hex totem, they see it's Aura."
  },
  hex_retribution: {
    sourceName: 'Hex: Retribution',
    officialDescription: 'When the trial starts, a Dull Totem ignites.\nWhenever a Survivor starts blessing or cleansing a Totem, they gain Oblivious for 60s.\nWhenever a Hex Totem is blessed or cleansed, you see the Auras of all Survivors for 20s.'
  },
  hex_ruin: {
    sourceName: 'Hex: Ruin',
    officialDescription: 'When the trial starts, a Dull Totem ignites.\nWhile a Generator is not being repaired, it regresses at 150% speed.'
  },
  hex_the_third_seal: {
    sourceName: 'Hex: The Third Seal',
    officialDescription: 'When the trial starts, a Dull Totem ignites.\nWhenever you damage a Survivor, they gain Blindness.\nThis applies for up to 4 Survivors.'
  },
  hex_thrill_of_the_hunt: {
    sourceName: 'Hex: Thrill of the Hunt',
    officialDescription: 'When the trial starts, a Dull Totem ignites.\nFor each Dull and Hex Totem remaining, you have 1 Token.\nFor each Token, Survivors bless and cleanse totems 12% slower.'
  },
  hex_two_can_play: {
    sourceName: 'Hex: Two Can Play',
    officialDescription: 'While this Hex is dull, each time you are blinded or stunned by a Survivor 2 times, a Dull Totem ignites.\nWhenever you are blinded or stunned by a Survivor you are not carrying, they are blinded for 1.5s.'
  },
  hex_undying: {
    sourceName: 'Hex: Undying',
    officialDescription: 'When the trial starts, a Dull Totem ignites.\nWhen another Hex Totem is blessed or cleansed, it replaces this one and keeps any Tokens it had.\nYou see the Auras of Survivors within 4m of Dull Totems.'
  },
  hex_wretched_fate: {
    sourceName: 'Hex: Wretched Fate',
    officialDescription: "The first time a Generator is completed, a Dull Totem ignites.\nThe Obsession:\nRepairs 33% slower.\nSees the Hex Totem's Aura within 12m."
  },
  hoarder: {
    sourceName: 'Hoarder',
    officialDescription: 'When the trial starts, 2 more Chests appear.\nWhenever a Survivor picks-up an item or starts unlocking a Chest within 64m of you, you are alerted.'
  },
  hubris: {
    sourceName: 'Hubris',
    officialDescription: 'Whenever you are stunned by a Survivor, they gain Exposed for 30s. Cooldown: 20s.'
  },
  human_greed: {
    sourceName: 'Human Greed',
    officialDescription: 'Whenever a Survivor gets within 8m of a locked Chest, you see their Aura for 5s.\nYou can lock unlocked Chests. Cooldown: 10s.\nYou see the Auras of locked Chests.'
  },
  hysteria: {
    sourceName: 'Hysteria',
    officialDescription: 'Whenever a healthy Survivor becomes injured, all injured Survivors gain Oblivious for 40s. Cooldown: 20s.'
  },
  i_m_all_ears: {
    sourceName: "I'm All Ears",
    officialDescription: 'Whenever a Survivor fast-enters or fast-exits a Locker, or medium or fast-vaults within 48m of you, you see their Aura for 8s. Cooldown: 30s.'
  },
  infectious_fright: {
    sourceName: 'Infectious Fright',
    officialDescription: 'Whenever a Survivor is downed, Survivors within your Terror Radius scream and you are alerted for 6s.'
  },
  insidious: {
    sourceName: 'Insidious',
    officialDescription: 'After being idle for 1s, you gain Undetectable until you act.'
  },
  iron_grasp: {
    sourceName: 'Iron Grasp',
    officialDescription: 'While carrying a Survivor:\nThey wiggle 12% slower.\nTheir wiggle is 75% weaker.'
  },
  iron_maiden: {
    sourceName: 'Iron Maiden',
    officialDescription: 'Whenever a Survivor exits a Locker:\nThey gain Exposed for 30s.\nThey scream, then you are alerted to their location for 4s.\nYou open Lockers 50% faster.'
  },
  knock_out: {
    sourceName: 'Knock Out',
    officialDescription: 'Whenever a Survivor drops a Pallet, for the next 6s, if they move 6m away from it, they gain 5% Hindered for 5s.'
  },
  languid_touch: {
    sourceName: 'Languid Touch',
    officialDescription: 'Whenever a Survivor within 36m of you scares a Crow, they gain Exhausted for 10s. Cooldown: 5s.'
  },
  lethal_pursuer: {
    sourceName: 'Lethal Pursuer',
    officialDescription: "When the trial starts, you see the Auras of all Survivors for 9s.\nWhenever you see a Survivor's Aura for a duration, it is 2s longer."
  },
  leverage: {
    sourceName: 'Leverage',
    officialDescription: 'Whenever a Survivor unhooks another or themselves, they heal 30% slower for 60s.'
  },
  lightborn: {
    sourceName: 'Lightborn',
    officialDescription: 'Whenever a Survivor attempts to blind you, you see their Aura for 10s.\nYou cannot be blinded.'
  },
  machine_learning: {
    sourceName: 'Machine Learning',
    officialDescription: 'Whenever you damage a Generator, it becomes compromised.\nWhen that Generator is completed by Survivors:\nYou gain 8% Haste for 60s.\nYou gain Undetectable for 60s.\nOnly one Generator can be compromised at a time.'
  },
  mad_grit: {
    sourceName: 'Mad Grit',
    officialDescription: 'While carrying a Survivor:\nWhenever you miss a basic attack, your cooldown is 100% shorter.\nWhenever you damage a Survivor with a basic attack, the carried Survivor gains no wiggle progress for 4s.'
  },
  make_your_choice: {
    sourceName: 'Make your Choice',
    officialDescription: 'Whenever a Survivor unhooks another or themselves while you are at least 32m away:\nThey scream.\nThey gain Exposed for 60s.\nCooldown: 60s.'
  },
  merciless_storm: {
    sourceName: 'Merciless Storm',
    officialDescription: 'The first time each Generator has 90% progress: Survivors repairing it get special Skill Checks. If they miss one of these or stop repairing, that Generator is blocked for 20s.'
  },
  mindbreaker: {
    sourceName: 'Mindbreaker',
    officialDescription: 'While Survivors are repairing a Generator:\nThey gain Blindness.\nThey gain Exhausted.\nWhen they stop repairing a Generator, this ends after 5s.'
  },
  monitor_abuse: {
    sourceName: 'Monitor & Abuse',
    officialDescription: 'While chasing a Survivor, your Terror Radius is 15% bigger.\nWhile not chasing a Survivor, your Terror Radius is 25% smaller.'
  },
  nemesis: {
    sourceName: 'Nemesis',
    officialDescription: 'Whenever a Survivor blinds you, Locker-stuns or Pallet-stuns you, they become the Obsession.\nWhenever a Survivor becomes the Obsession:\nThey gain Oblivious for 60s.\nYou see their Aura for 8s.'
  },
  no_quarter: {
    sourceName: 'No Quarter',
    officialDescription: 'While self-healing, whenever a Survivor has 75% progress, they get special Skill Checks. If they miss one of these or stop healing, they gain Broken for 30s.'
  },
  no_way_out: {
    sourceName: 'No Way Out',
    officialDescription: 'The first time you hook each Survivor, you earn 1 Token.\nWhen all Generators are completed, when a Survivor starts opening an Exit Gate:\nIt is blocked 12s, plus 12s for each Token.\nYou are alerted.'
  },
  none_are_free: {
    sourceName: 'None Are Free',
    officialDescription: 'The first time you hook each Survivor, earn 1 Token.\nWhen all Generators are completed, for each Token:\nUpright Pallets are blocked for 16s.\nWindows are blocked for 16s.'
  },
  nowhere_to_hide: {
    sourceName: 'Nowhere to Hide',
    officialDescription: 'Whenever you damage a Generator, for 5s, you see the Auras of Survivors within 24m of you.'
  },
  oppression: {
    sourceName: 'Oppression',
    officialDescription: 'Whenever you damage a Generator, up to 4 other Generators start regressing. Survivors repairing them get a special Skill Check. Cooldown: 35s.'
  },
  overcharge: {
    sourceName: 'Overcharge',
    officialDescription: 'Whenever you damage a Generator:\nIts regression speed will go from 85% to 130% over the next 30s.\nThe next Survivor who starts repairing it gets a special Skill Check. If they miss it, they lose 4% more progress.'
  },
  overwhelming_presence: {
    sourceName: 'Overwhelming Presence',
    officialDescription: "Whenever a Survivor uses an item within 32m of you, they gain Exhausted for 15s.\nWhenever a Survivor within 32m of you gains Exhausted, you see the closest Exhausted Survivor's Aura for 4s. Cooldown: 25s."
  },
  phantom_fear: {
    sourceName: 'Phantom Fear',
    officialDescription: 'Whenever a Survivor within your Terror Radius looks at you, they scream, then you see their Aura for 2s. Cooldown: 60s.'
  },
  play_with_your_food: {
    sourceName: 'Play With Your Food',
    officialDescription: 'Whenever you stop chasing the Obsession, you earn 1 Token, up to 3.\nFor each Token, gain 5% Haste.\nWhenever you attack, lose 1 Token.'
  },
  pop_goes_the_weasel: {
    sourceName: 'Pop Goes the Weasel',
    officialDescription: 'Whenever you hook a Survivor, for the next 45s, when you damage a Generator, it explodes and loses 15% more progress.'
  },
  predator: {
    sourceName: 'Predator',
    officialDescription: 'When you stop chasing a Survivor, you see their Aura for 4s. Cooldown: 40s.'
  },
  rancor: {
    sourceName: 'Rancor',
    officialDescription: 'Whenever a Generator is completed:\nYou are alerted to the position of all Survivors for 3s.\nThe Obsession sees your Aura for 3s.\nWhen all Generators are completed:\nThe Obsession gains Exposed.\nYou can Kill the Obsession.'
  },
  rapid_brutality: {
    sourceName: 'Rapid Brutality',
    officialDescription: 'Whenever you damage a Survivor with a basic-attack, you gain 5% Haste for 10s.\nWhile chasing a Survivor, you cannot gain Bloodlust.'
  },
  ravenous: {
    sourceName: 'Ravenous',
    officialDescription: 'The first time you hook each Survivor, you earn 1 Token.\nWhen you have 4 Tokens, all Survivors:\nScream.\nGain Exposed for 60s.'
  },
  remember_me: {
    sourceName: 'Remember Me',
    officialDescription: 'Whenever the Obsession takes damage, you earn 1 Token, up to 3/4/5.\nFor each Token, Survivors who are not the Obsession open Exit Gates 30% slower.'
  },
  save_the_best_for_last: {
    sourceName: 'Save the best for last',
    officialDescription: 'Whenever you damage a Survivor who is not the Obsession with a basic-attack, you earn 1 Token, up to 6/7/8.\nFor each Token, your basic-attack cooldown are 4% shorter.\nWhenever the Obsession takes damage, lose 2 Tokens.\nWhile the Obsession is dead, you cannot earn Tokens.'
  },
  scourge_hook_floods_of_rage: {
    sourceName: 'Scourge Hook: Floods of Rage',
    officialDescription: 'When the trial starts, 4 random Hooks become Scourge Hooks.\nWhenever a Survivor is unhooked from a Scourge Hook, you see the Auras of other Survivors for 7s.'
  },
  scourge_hook_gift_of_pain: {
    sourceName: 'Scourge Hook: Gift of Pain',
    officialDescription: 'When the trial starts, 4 random Hooks become Scourge Hooks.\nWhenever a Survivor is unhooked from a Scourge Hook:\nThey gain Hemorrhage for 90s.\nThey gain Mangled for 90s.\nWhen they are healed, until they take damage, they heal and repair 16% slower.'
  },
  scourge_hook_hangman_s_trick: {
    sourceName: "Scourge Hook: Hangman's Trick",
    officialDescription: 'When the trial starts, 4 random Hooks become Scourge Hooks.\nWhile carrying a Survivor, you see the Auras of Survivors within 16m of Scourge Hooks.\nWhenever a Survivor starts sabotaging a Hook, you are alerted.'
  },
  scourge_hook_jagged_compass: {
    sourceName: 'Scourge Hook: Jagged Compass',
    officialDescription: 'When the trial starts, 4 random Hooks become Scourge Hooks.\nWhenever a Survivor is unhooked, the Hook becomes a Scourge Hook.\nWhenever you hook a Survivor on a Scourge Hook, for 10s, you see the Aura of the Generator with the most progress.'
  },
  scourge_hook_monstrous_shrine: {
    sourceName: 'Scourge Hook: Monstrous Shrine',
    officialDescription: 'When the trial starts:\n4 random Hooks become Scourge Hooks.\nThe Basement Hooks become Scourge Hooks.\nWhile you are at least 24m away from a Survivor on a Scourge Hook, they are sacrificed 20% faster.'
  },
  scourge_hook_pain_resonance: {
    sourceName: 'Scourge Hook: Pain Resonance',
    officialDescription: 'When the trial starts:\n4 random Hooks become Scourge Hooks.\nYou earn 4 Tokens.\nThe first time each Survivor is hooked on a Scourge Hook, spend 1 Token, then the Generator with the most progress:\nExplodes, loses 20% progress and starts regressing.\nSurvivors repairing it scream.'
  },
  secret_project: {
    sourceName: 'Secret Project',
    officialDescription: 'Whenever a totem is blessed or cleansed, a random unblocked Generator is blocked for 30s.\nWhenever 1 or more Generators are blocked, you gain Undetectable for 30s.'
  },
  septic_touch: {
    sourceName: 'Septic Touch',
    officialDescription: 'While a Survivor within your Terror Radius is healing:\nThey gain Blindness.\nThey gain Exhausted.\nWhen they stop healing, this ends after 30s.'
  },
  shadowborn: {
    sourceName: 'Shadowborn',
    officialDescription: 'Whenever you are blinded, gain 10% Haste for 10s.'
  },
  shattered_hope: {
    sourceName: 'Shattered Hope',
    officialDescription: 'Whenever you snuff a Boon Totem:\nYou see the Auras of all Survivors within its range for 8s.\nIt is destroyed.'
  },
  sloppy_butcher: {
    sourceName: 'Sloppy Butcher',
    officialDescription: 'Whenever you damage a Survivor with a basic-attack:\nThey gain Hemorrhage for 90s.\nThey gain Mangled for 90s.\nSurvivors with Hemorrhage lose healing progress 25% faster.'
  },
  spies_from_the_shadows: {
    sourceName: 'Spies from the Shadows',
    officialDescription: 'Whenever a Survivor scares a Crow within 36m of you, you are alerted. Cooldown: 5s.'
  },
  spirit_fury: {
    sourceName: 'Spirit Fury',
    officialDescription: 'After you break 2 Pallets, when you are Pallet-stunned, the Pallet is destroyed.'
  },
  starstruck: {
    sourceName: 'Starstruck',
    officialDescription: 'While carrying a Survivor, Survivors within your Terror Radius gain Exposed. This ends 30s after:\nThey leave your Terror Radius.\nYou drop or hook the carried Survivor.\nCooldown: 60s.'
  },
  stridor: {
    sourceName: 'Stridor',
    officialDescription: "Survivors' breathing noises are 25% louder and their Grunts of Pain are 50% louder."
  },
  superior_anatomy: {
    sourceName: 'Superior Anatomy',
    officialDescription: 'Whenever a Survivor fast-vaults within 12m of you, the next time you basic-vault a window, it is 40% faster. Cooldown: 25s.'
  },
  surge: {
    sourceName: 'Surge',
    officialDescription: 'Whenever you down a Survivor with a basic-attack, Generators within 32m:\nExplode, lose 8% progress and start regressing.\nSurvivor repairing them scream.'
  },
  surveillance: {
    sourceName: 'Surveillance',
    officialDescription: 'You see the Auras of regressing Generators.\nWhenever a Generator stops regressing, you see its Aura for 16s.\nGenerator repair noises can be heard from 8m farther away.'
  },
  terminus: {
    sourceName: 'Terminus',
    officialDescription: 'When all Generators are completed: all injured, downed, and hooked Survivors gain Broken.\nWhen an Exit Gate is opened, this ends after 45s.'
  },
  territorial_imperative: {
    sourceName: 'Territorial Imperative',
    officialDescription: 'Whenever a Survivor enters the Basement while you are 24m away from it, you see their Aura for 6s. Cooldown: 45s.'
  },
  thanatophobia: {
    sourceName: 'Thanatophobia',
    officialDescription: 'For each injured, downed, or hooked Survivor, all Survivors:\nCleanse totems 2% slower.\nRepair 2% slower.\nSabotage Hooks 2% slower.\nWhile 4 Survivors are either injured, downed or hooked, all above actions are additionally 12% slower.'
  },
  thrilling_tremors: {
    sourceName: 'Thrilling Tremors',
    officialDescription: 'Whenever you pick-up a Survivor, all Generators not being repaired are blocked for 16s. Cooldown: 30s.'
  },
  thwack: {
    sourceName: 'THWACK!',
    officialDescription: 'When the trial starts, you earn 3 Tokens, up to 3.\nWhenever you hook a Survivor, you earn 1 Token.\nWhenever you break a Pallet or Breakable Wall, spend 1 Token. Then, all Survivors within 36m scream and you see their Auras for 6s.'
  },
  tinkerer: {
    sourceName: 'Tinkerer',
    officialDescription: 'The first time each Generator has 70% progress:\nYou gain Undetectable for 16s.\nYou are alerted.'
  },
  trail_of_torment: {
    sourceName: 'Trail of Torment',
    officialDescription: "Whenever you damage a Generator, until it stops regressing:\nYou gain undetectable.\nSurvivors see that Generator's Aura.\nCooldown: 30s."
  },
  turn_back_the_clock: {
    sourceName: 'Turn Back The Clock',
    officialDescription: 'After hooking a Survivor, for the next 60s, use Active Ability Button 1 to make target Generator you can see within 20m explode, lose 10% progress and start regressing.'
  },
  ultimate_weapon: {
    sourceName: 'Ultimate Weapon',
    officialDescription: 'Whenever you search a Locker, Survivors within 40m:\nGain Blindness for 30s.\nScream.\nCooldown: 45s.'
  },
  unbound: {
    sourceName: 'Unbound',
    officialDescription: 'Whenever a Survivor takes damage, for the next 30s, whenever you basic-vault a window, gain 7% Haste for 10s.'
  },
  undone: {
    sourceName: 'Undone',
    officialDescription: 'Whenever a Survivor misses a basic Skill Check, earn 3 Tokens, up to 18/24/30.\nWhenever you damage a Generator, spend all Tokens. For each Token spent:\nThe Generator loses 1% progress.\nThe Generator is blocked for 1s.\nWhen that Generator is unblocked, it begins regressing. Cooldown: 60s.'
  },
  unforeseen: {
    sourceName: 'Unforeseen',
    officialDescription: 'Whenever you damage a Generator:\nYour Terror Radius is set to that Generator for 30s and its radius is 32m.\nYou gain Undetectable for that time.\nCooldown: 30s.'
  },
  unnerving_presence: {
    sourceName: 'Unnerving Presence',
    officialDescription: 'Survivors within your Terror Radius get 10% more basic Skill Checks.\nThe good zone of basic Skill Checks is 60% smaller.'
  },
  unrelenting: {
    sourceName: 'Unrelenting',
    officialDescription: 'Whenever you miss a basic-attack, your cooldown is 30% shorter.'
  },
  wandering_eye: {
    sourceName: 'Wandering Eye',
    officialDescription: 'Whenever you start chasing a Survivor, for the next 5s, you see the Auras of all other injured Survivors within 20m. Cooldown: 30s.'
  },
  weave_attunement: {
    sourceName: 'Weave Attunement',
    officialDescription: "The first time each item is depleted, it is dropped.\nWhile a Survivor is within 12m of a dropped item:\nYou see their Aura.\nThey see the item's Aura.\nWhenever a Survivor picks-up an item, they gain Oblivious for 30s."
  },
  whispers: {
    sourceName: 'Whispers',
    officialDescription: 'While within 32m of a Survivor, you randomly hear whispers.'
  },
  zanshin_tactics: {
    sourceName: 'Zanshin Tactics',
    officialDescription: 'Within 32m, you see the Auras of Pallets and windows.\nWhenever a Survivor drops a Pallet, you see their Aura for 5s.'
  }
}
